import { render, staticRenderFns } from "./LandingBenefits.html?vue&type=template&id=2f3e16d3&scoped=true&"
import script from "./LandingBenefits.ts?vue&type=script&lang=ts&"
export * from "./LandingBenefits.ts?vue&type=script&lang=ts&"
import style0 from "./LandingBenefits.scss?vue&type=style&index=0&id=2f3e16d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e16d3",
  null
  
)

export default component.exports